import type { FC } from "react";
import React from "react";

import { AppHeader } from "@react/foundation/app";
import { AppContainer, PageContainer } from "@react/web/app";

import { MONITORING_SERVICE } from "@apis/monitoring/config";

import { HealthHistory } from "./features/health-history/index.ts";

const PROBE_TARGETS = [
  {
    name: "Account Service",
    target: MONITORING_SERVICE.PROBE_TARGETS.accountService,
  },
  { name: "Database", target: MONITORING_SERVICE.PROBE_TARGETS.database },
] as const;

export const App: FC = () => (
  <AppContainer>
    <AppHeader title="AptBlocks" />
    <PageContainer>
      <div className="flex flex-col gap-4">
        {PROBE_TARGETS.map(({ name, target }) => (
          <HealthHistory key={target} name={name} target={target} />
        ))}
      </div>
    </PageContainer>
  </AppContainer>
);
